// One-tap answers to closed follow-ups, read by the backend without the model (VisitorReply::QUICK_REPLIES): change both lists together.
export const QUICK_REPLIES: Record<string, string[]> = {
  smoker: ['Non-fumeur', 'Fumeur'],
  hasCoBorrower: ["J'emprunte seul", 'Avec un co-emprunteur'],
  coSmoker: ['Non-fumeur', 'Fumeur'],
  projectStatus: ["J'ai un projet d'achat", "J'ai déjà un prêt", 'Je me renseigne'],
  projectType: ['Nouveau prêt', "Je change d'assurance"],
  loanType: ['Résidence principale', 'Investissement locatif', 'Prêt professionnel'],
};

export function quickRepliesFor(field: string | null | undefined): string[] {
  return field ? QUICK_REPLIES[field] ?? [] : [];
}
